module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.weeknoteId) ? _c('div', {
    staticClass: "weekplan-weeknote-log text-dark ww"
  }, [_c('button', {
    on: {
      "click": _vm.setShowHistory
    }
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.weeknote_log.activity')))]), _vm._v(" "), (_vm.isShowHistory) ? _c('DModal', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "ww-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "ww-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.saved_versions')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ww-modal__body"
  }, [_c('div', {
    staticClass: "ww-modal__body__sidebar"
  }, [(_vm.logSorted.length === 0) ? _c('h3', {
    staticClass: "marg-20-bottom text-explainer italic"
  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.no_saved_versions')))]) : _c('p', {
    staticClass: "sidebar__headline"
  }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.choose_versions_to_compare')))]), _vm._v(" "), _c('ul', _vm._l((_vm.logSorted), function(activity, key) {
    return _c('li', {
      staticClass: "log-list__item",
      class: {
        'log-list__item--active': _vm.isInActiveIdx(key)
      },
      attrs: {
        "aria-number": _vm.revertedKey(activity)
      },
      on: {
        "click": function($event) {
          return _vm.setVersion(activity)
        }
      }
    }, [_c('div', {
      staticClass: "log-list__item__header"
    }, [_c('div', [_vm._v(_vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')))]), _vm._v(" "), (_vm.isNewestVersion(activity)) ? _c('div', {
      staticClass: "pill"
    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "log-cards"
  }, _vm._l((_vm.latestActivity), function(activity, key) {
    return _c('div', {
      staticClass: "log-cards__card"
    }, [_c('div', {
      staticClass: "log-cards__card__header"
    }, [_c('h6', [_vm._v("\n                " + _vm._s(_vm.showHumanizedTime(activity.at)) + " " + _vm._s(_vm.$t('vue2.common.ago')) + "\n                "), (_vm.isNewestVersion(activity)) ? _c('span', {
      staticClass: "pill"
    }, [_vm._v(_vm._s(_vm.$t('vue2.weeknote_log.current_version')))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.showUser(activity.by)))]), _vm._v(", " + _vm._s(_vm.showDate(activity.at)))])]), _vm._v(" "), _c('div', {
      staticClass: "log-cards__card__content",
      domProps: {
        "innerHTML": _vm._s(activity.note)
      }
    })])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowHistory) ? _c('div', {
    staticClass: "bg-overlay"
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f30ccd7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Weekplan/DoWeekPlanLog.vue
// module id = 1778
// module chunks = 1